module.exports = __webpack_public_path__ + "static/media/fctrz.114e97f2.webp";